var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"300px"},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}},[_c('el-option',{attrs:{"label":"50拆包规则7+50+2","value":"1"}}),_c('el-option',{attrs:{"label":"32拆包规则8+32+2","value":"2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }